import React, { useEffect, useState } from 'react';
import { Box, IconButton } from "@mui/material";
import { useDispatch } from 'react-redux';
import CloseIcon from '../../assets/images/CloseIcon.png';
import LeftArrow from '../../assets/images/MobilePreviewArrow.png'; // same image both times; we rotate
import RightArrow from '../../assets/images/MobilePreviewArrow.png';
import PlayIcon from '../../assets/images/PlayIcon.png';
import * as appActions from '../../Actions/app';
import { useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import "./LevelPreview.css"
import { useNavigate } from 'react-router-dom';
import { Completion } from './PlayContainer';

const LevelPreview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [currentIndex, setCurrentIndex] = useState(0);

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer)
  
  // We will assess their latest place in the level based on what is shown in the userLevelData
  const {
    levelData,
    levelSelect,
    userLevelData,
    tiersByLevels,
  } = data

  let selectedLevel = levelData[levelSelect] || levelData[0]
  let level_number = selectedLevel ? selectedLevel.level_number : 0
  let selectedLevelProgress
  userLevelData.forEach(ul => {
    if (ul?.level?.level_number == level_number) {
      selectedLevelProgress = ul
    }
  })
  let highestTierComplete = 0
  if (selectedLevelProgress && Object.keys(selectedLevelProgress).length > 0) {
    highestTierComplete = (selectedLevelProgress as any).highest_tier_complete
  }
  let tierByLevel = tiersByLevels ? tiersByLevels.find(item => item.level_number === level_number) : undefined
  let tierCountForLevel = tierByLevel?.tiers?.length ||  1

  const handleNext = () => {
    // setCurrentIndex((prevIndex) => (prevIndex + 1) % levels.length);
    dispatch(appActions.setLevelSelect({ levelSelect: (levelSelect + 1) % levelData.length }));
  };

  const handlePrev = () => {
    // setCurrentIndex((prevIndex) => (prevIndex - 1 + levels.length) % levels.length);
    dispatch(appActions.setLevelSelect({ levelSelect: (levelSelect - 1 + levelData.length) % levelData.length }));
  };


  const onPlay = () => {
    // Will grab tutorials and redirect in the sagas
    dispatch(appActions.fetchTutorialData())
    // Level 0 is tutorial-only (no sight reading stage), so always go to tutorial
    // For other levels, skip tutorial if user has completed at least one tier
    if (highestTierComplete >= 1 && level_number > 0) {
      navigate(`/lesson`)
    } else {
      navigate(`/tutorial`)
    }
  } 

  return (
    <Box
      sx={{
        zIndex: 100,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        // backgroundColor: 'rgba(29, 47, 68, 0.55)',
        backgroundColor: 'rgba(59, 77, 98, 0.80)',
        // backgroundColor: 'rgba(0, 0, 0, 0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Carousel Wrapper */}
      <Box
        sx={{
          position: 'relative',
          // width: '800px',
          width: '100%',
          height: '400px',
          borderRadius: '10px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // backgroundColor: 'red',
        }}
      >

        {/* Left Arrow */}
        <IconButton
          onClick={handlePrev}
          sx={{
            position: 'absolute',
            // left: '100px',
            // top: '50%',
            // transform: 'translateY(-50%)',
            left: '50%',
            top: '50%',
            transform: 'translate(-456px, -50%)',
            // backgroundColor: 'rgba(0, 0, 0, 0.5)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
            zIndex: 2
          }}
        >
          <img src={LeftArrow} alt="Previous" style={{ width: '50px', transform: 'rotate(180deg)' }} />
        </IconButton>

        {/* Image Carousel */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
        >
          


          {/* {levels.map((image, index) => { */}
          {levelData.map((selectedLevel, index) => {
            // console.log("rendering?")
            // let selectedLevel = levelData[levelSelect] || levelData[0]

            // Calculate relative position (-1, 0, 1) based on the current index
            const position = (index - levelSelect + levelData.length) % levelData.length;
            
            let translateX, scale, opacity;

            if (position === 0) {
              // Centered (main image)
              translateX = '0%';
              scale = 1;
              opacity = 1;
            } else if (position === 1) {
              // Next image on the right
              translateX = '100%';
              scale = 0.8;
              opacity = 0.75;
            } else if (position === levelData.length - 1) {
              // Previous image on the left
              translateX = '-100%';
              scale = 0.8;
              opacity = 0.75;
            } else {
              // Further back (if more images)
              translateX = position === 2 ? '200%' : '-200%';
              scale = 0.6;
              opacity = 0;//0.3;
            }
            console.log(`https://${selectedLevel.srcs}`)
            
            return (
              <Box
                key={index}
                sx={{
                  position: 'absolute',
                  transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
                  transform: `translateX(${translateX}) scale(${scale})`,
                  opacity: opacity,
                  width: '700px',
                  height: '390px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  background: 'linear-gradient(90deg, #071423, #1D2F44)',
                  // backgroundColor: 'red',
                }}
              >
                {/* { (position == 0) && */}
                  <img 
                    onClick={() => dispatch(appActions.setShowLevelPreview(false))}
                    src={CloseIcon}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      width: '30px',
                      cursor: 'pointer',
                      opacity: '70%',
                    }}
                    alt="Close"
                  />
                {/* } */}

                <Box sx={{display: 'flex', flexDirection: 'column', gap: '24px', }}>
                  <Box className="level-carousel-title" sx={{marginTop: '12px', textTransform: 'uppercase'}}>
                    {`LEVEL ${selectedLevel.level_number}: ${selectedLevel ? selectedLevel.name : ""}`}
                  </Box>
                  <Box className="level-carousel-desc" sx={{margin: 'auto 40px',}}>
                    {selectedLevel?.description}
                  </Box>
                  
                  <Box sx={{width: '90%', margin: 'auto',}}>
                    <Completion highestTierComplete={highestTierComplete} tierCountForLevel={tierCountForLevel}/>
                  </Box>

                  <Box sx={{display: 'flex', alignItems: 'center',}}>
                    <Box sx={{
                      height: '164px',//'152px', 
                      backgroundColor: 'rgba(226,226,226)', 
                      display: 'flex', alignItems: 'flex-end',
                      maxWidth: '99%', 
                      borderTopRightRadius: '12px',
                      borderBottomRightRadius: '12px',
                      position: 'relative',
                      }}>
                        <Box className={"play-text-styles"} sx={{color: 'rgba(50,50,50)', position: 'absolute', top: '10px', left: '15px'}}>
                          PREVIEW
                        </Box>
                      <img style={{
                        // marginLeft: '8px', marginRight: '8px', 
                        maxWidth: '99%', 
                        maxHeight: '190px'}} src={`https://${selectedLevel.srcs}`}/>
                    </Box>
                    <Box sx={{border: '2px solid #616A75', borderRadius: '12px', padding: '8px 20px 32px 20px', margin: '8px', }}>
                      <Box className={"play-text-styles"} sx={{letterSpacing: '0.61px', margin: '0px 10px 22px 10px'}}>PLAY</Box>
                      <Box 
                        onClick={() => {
                          onPlay() 
                        }} className="play-container-styles">
                          <img src={PlayIcon}/>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>

        {/* Right Arrow */}
        <IconButton
          onClick={handleNext}
          sx={{
            position: 'absolute',
            // right: '100px',
            // top: '50%',
            // transform: 'translateY(-50%)',
            right: '50%',
            top: '50%',
            transform: 'translate(456px, -50%)',
            // backgroundColor: 'rgba(0, 0, 0, 0.5)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
            zIndex: 2
          }}
        >
          <img 
            src={RightArrow} 
            alt="Next" 
            style={{ width: '50px' }} 
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default LevelPreview;
